
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)


/*MODULES*/
import formulariosModule from '@/store/formularios'
import authModule from '@/store/authmodule'
import eventosModule from '@/store/eventosModule'
import encuestasModule from '@/store/encuestasModule'
import orientacionModule from '@/store/orientacionModule'
import cvModule from '@/store/cvModule'
import dominiosModule from '@/store/dominiosModule'
import errorModule from '@/store/errorModule'
import candidaturasModule from '@/store/candidaturasModule'
import testimoniosModule from '@/store/testimoniosModule'
import independientesModule from '@/store/programasIndependientesModule'
import ofertasModule from '@/store/ofertasModule'
import empresasModule from '@/store/empresasModule'

import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';

import messages from '@/translations';

import appinfo from '../../package.json';


let servers = {
  //"localhost" : "http://localhost:51642/",
  "localhost" : "https://sandbox.practicasyempleoufv.es/",
  //"localhost" : "https://back.practicasyempleoufv.es/",
  "practicasyempleoufv.es" : "https://back.practicasyempleoufv.es/",
  "dev-portal.practicasyempleoufv.es" : "https://sandbox.practicasyempleoufv.es/",
  "ufv-practicas-privado.dev.doubledot.es" : "https://sandbox.practicasyempleoufv.es/"
}


export const store = new Vuex.Store({
  state :{
    language: localStorage.getItem('language') || 'es',
    server : servers[location.hostname],
    packageVersion : appinfo.version
  },
  actions :{
    changeLanguage : ({commit}, actualLang) => {
      return new Promise((resolve, reject) => {
        let nextLang = (actualLang == "es") ? "en" : "es";
        commit('setLanguage', nextLang);
        switch (nextLang) {
          case "es":
          Validator.localize('es', validatorEs);
          break;
          case "en":
          Validator.localize('en', validatorEn);
          break;
        }
        resolve(nextLang);
      });
    },
  },
  getters : {
    getVersion : state => state.packageVersion,
    getLanguage : state => state.language,
    getServer : state => state.server,
    getTexts : state => {
      return messages[state.language];
    }
  },
  mutations : {
    setLanguage (state, lang){
      state.language = lang;
      localStorage.setItem('language', lang);      
    }
  },
  modules :{
    formulariosModule,
    authModule,
    eventosModule,
    encuestasModule,
    dominiosModule,
    orientacionModule,
    cvModule,
    candidaturasModule,
    errorModule,
    testimoniosModule,
    independientesModule,
    ofertasModule,
    empresasModule
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js